<template>
  <Modal v-model="visible" title="申请保函续保" @on-cancel="closeModal">
    <Form ref="renewalForm" :model="renewalModel" :label-width="140" label-position="left">
      <FormItem
        label="续保截止时间"
        prop="renewalEndTime"
        :rules="{required: true, message: '请填写续保截止时间', trigger: 'blur'}">
        <DatePicker v-model="renewalModel.renewalEndTime"
          type="datetime"
          placement="bottom-end"
          format="yyyy-MM-dd HH:mm:ss"
          @on-change="changeEndDate"
          placeholder="选择续保截止时间"
          style="width: 200px"></DatePicker>
      </FormItem>
      <FormItem :label="fileReq.name" :prop="`attachments[${getAttachmentIndex(idx)}].url`"
        v-for="(fileReq,idx) in fileRequirements"
        :key="idx"
        :rules="fileReq.required?[{required:true,message:'必填',trigger:'blur'}]:null">
        <Upload
          :data="OSSParam"
          :before-upload="handleBeforeUpload"
          :multiple="fileReq.fileCountLimit>1"
          :on-success="handleUploadSuccess"
          :format="fileReq.formats!=='*'?fileReq.formats.split(','):[]"
          :on-format-error="handleFormatError"
          :show-upload-list="false"
          :action="uploadParams.host">
          <Poptip trigger="hover" placement="right">
            <Button @click="getOSSParams(idx+1, fileReq.name, 3)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
            <div slot="content">
              <p>{{fileReq.description}}</p>
              <p>格式限制：{{fileReq.formats}}</p>
              <p>大小限制：{{fileReq.maxLength}}kb</p>
            </div>
          </Poptip>
        </Upload>
        <div class="contract" v-if="renewalModel.attachments&&renewalModel.attachments instanceof Array&&renewalModel.attachments.length">
          <template v-if="currentFileRequirement(idx)&&currentFileRequirement(idx).urls&&(currentFileRequirement(idx).urls instanceof Array)&&currentFileRequirement(idx).urls.length">
            <div class="contract-thumb" v-for="(item,upIdx) in currentFileRequirement(idx).urls" :key="upIdx">
              <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
              <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
              <div class="contract-thumb-cover">
                <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='image'" @click="handleImgPreview(currentFileRequirement(idx).urls, upIdx)"></Icon>
                <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='file'" @click="previewImgUrl=item;showPreview=true"></Icon>
                <Icon type="ios-trash-outline" @click="removeAttachmentItem(item,idx)"></Icon>
              </div>
            </div>
          </template>
        </div>
      </FormItem>
    </Form>
    <div slot="footer">
      <Poptip
        confirm
        title="您确认申请续保该保函么？"
        @on-ok="submit">
        <Button type="error">
          提交
        </Button>
      </Poptip>
      <Button type="default" @click="closeModal" style="margin-left:5px">
        取消
      </Button>
    </div>
    <CertSelectModal
      :show="showCertSelectModal"
      :dataSigning="dataToSign"
      :mode="signMode"
      @cert-verified="certSigned"
      :callback="signCallback"
      @close-modal="showCertSelectModal=false" />
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
  </Modal>
</template>

<script>
import Api from './../../api/Api.js'
import CertSelectModal from './../../components/CertSelectModal'
export default {
  name: 'GuaRenewalModal',
  props: {
    show: Boolean,
    guarantee: Object
  },
  components: {
    CertSelectModal
  },
  data () {
    return {
      visible: false,
      renewalModel: {
        guaranteeId: null,
        renewalEndTime: null,
        attachments: []
      },
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      curOSSParamIndex: null,
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      uploadList: [],
      uploadedContractArray: [],
      previewImgUrl: null,
      showPreview: false,
      fileRequirements: [],
      fileRequirementsUploaded: [],
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0,
      showCertSelectModal: false,
      dataToSign: null,
      signMode: 'normal',
      signCallback: null,
    }
  },
  watch: {
    'show': function (newVal) {
      this.visible = newVal
      if (newVal) {
        this.initFileRequirements()
      }
    },
    guarantee: function (newVal) {
      if (newVal) {
        this.renewalModel.guaranteeId = newVal.id
      } else {
        this.renewalModel.guaranteeId = null
      }
    }
  },
  mounted () {
    this.initFileRequirements()
  },
  methods: {
    initFileRequirements () {
      this.renewalModel.attachments = []
      this.fileRequirements = this.getSysConfig('GUARANTEE_RENEWAL_ATTACHMENT_REQUIREMENTS')
      if (this.fileRequirements instanceof Array) {
        this.fileRequirementsUploaded = []
        this.fileRequirements.forEach((f, fIdx) => {
          this.renewalModel.attachments.push({
            id: fIdx,
            ossKeys: [],
            fileUrls: [],
            name: f.name,
            url: null,
            urls: []
          })
          this.fileRequirementsUploaded.push({
            id: fIdx,
            ossKeys: [],
            fileUrls: []
          })
        })
      }
    },
    getAttachmentIndex (fileReqIdx) {
      let fileReq = this.fileRequirements[fileReqIdx]
      return this.renewalModel.attachments.findIndex(o => o.name === fileReq.name)
    },
    getSysConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getOSSParams (index, name, type = 1) {
      // type: 1-合同|2-竣工|3-其他
      Api.Guarantee.getUploadParams(type).then((res) => {
        console.log(res)
        this.uploadParams = {
          name: name,
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve, reject) => {
        try {
          let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
          if (surfix.indexOf('?')) {
            surfix = surfix.substring(0, surfix.indexOf('?'))
          }
          let type = 'image'
          switch (surfix) {
            case 'jpg':
              type = 'image'
              break
            case 'jpeg':
              type = 'image'
              break
            case 'png':
              type = 'image'
              break
            case 'gif':
              type = 'image'
              break
            case 'pdf':
              type = 'file'
              break
            case 'doc':
              type = 'file'
              break
            case 'docx':
              type = 'file'
              break
            case 'xls':
              type = 'file'
              break
            case 'xlsx':
              type = 'file'
              break
            case 'ppt':
              type = 'file'
              break
            case 'pptx':
              type = 'file'
              break
            default:
              type = 'file'
              break
          }
          let obj = {
            name: k,
            url,
            type,
            surfix
          }
          resolve(obj)
          return obj
        } catch (er) {
          reject(er)
        }
      })
    },
    procOssKeys (keys) {
      keys.forEach(async (k) => {
        try {
          if (typeof(k) === 'string') {
            let keyObj = await this.procOssKey(k)
            this.uploadedContractArray.push(keyObj)
          } else if (typeof(k) === 'object' && k.url) {
            this.uploadedContractArray.push({
              name: k.name,
              url: k.url,
              type: k.type,
              surfix: k.prefix
            })
          }
        } catch (e) {
          console.log(e)
        }
      })
      this.$nextTick(() => {
        this.uploadList = this.$refs.contractUploader.fileList
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    removeAttachmentItem (item, attachIdx) {
      let attach = this.currentFileRequirement(attachIdx)
      let idx = attach.urls.findIndex(o => o.name === item.name)
      attach.urls.splice(idx, 1)
      let keys = attach.url.split(',')
      keys.splice(idx, 1)
      keys = keys.join(',')
      console.log(keys)
      attach.url = keys
    },
    currentFileRequirement (idx) {
      let req = this.fileRequirements[idx]
      let att = this.renewalModel.attachments.find(o => o.name === req.name)
      return att
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: this.uploadParams.name,
        filename: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = this.uploadParams.name
      this.OSSParam.filename = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
    },
    async handleUploadSuccess (response, file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      let ossParam = this.OSSParams.filter((item) => {
        return item.filename === file.name
      })[0]
      console.log(ossParam)
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(async (keyObj) => {
          console.log(keyObj.url)
          file.url = keyObj.url
          this.fileRequirementsUploaded[ossParam.fileIndex - 1].ossKeys.push(filename)
          this.fileRequirementsUploaded[ossParam.fileIndex - 1].fileUrls.push(keyObj.url)
          let attachExist = this.renewalModel.attachments.filter((a) => {
            return a.name === ossParam.name
          })
          if (attachExist && attachExist.length) {
            if (typeof(attachExist[0].url) === 'string') {
              let urls = attachExist[0].url.split(',')
              if (urls.length) {
                urls.push(filename)
              } else {
                urls = [filename]
              }
              attachExist[0].url = urls.join(',')
            } else if (attachExist[0].url instanceof Array) {
              attachExist[0].url = attachExist[0].url.push(filename).join(',')
            } else {
              attachExist[0].url = filename
            }
            if (attachExist[0].urls) {
              attachExist[0].urls.push(keyObj)
            } else {
              console.log(222)
              attachExist[0].urls = []
              this.$nextTick(() => {
                attachExist[0].urls.push(keyObj)
                console.log(attachExist[0].urls)
              })
            }
          } else {
            console.log(111)
            this.renewalModel.attachments.push({
              name: ossParam.name,
              type: 3,
              url: filename,
              urls: [keyObj]
            })
          }
        })
        this.$nextTick(async () => {
          
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    handleImgPreview (list, index) {
      this.imageUrls = list.map((l) => {return l.url})
      this.visiblePreviewer = true
      this.startPosition = index
    },
    changeEndDate (dt) {
      this.renewalModel.renewalEndTime = dt
    },
    submit () {
      let needSign = this.getSysConfig('RENEWAL_NEED_SIGN')
      if (needSign) {
        this.dataToSign = JSON.stringify(this.renewalModel)
        this.signMode = 'normal'
        this.signCallback = this.doRenewGuarantee
        this.showCertSelectModal = true
      } else {
        this.dataToSign = this.renewalModel
        this.doRenewGuarantee(this.dataToSign, false)
      }
    },
    async doRenewGuarantee (certSigned, needSign) {
      this.$refs.renewalForm.validate(async (valid) => {
        if (valid) {
          this.$Spin.show()
          if (needSign) {
            Api.Guarantee.applyGuaranteeRenewal(certSigned)
            .then(() => {
              this.$Message.success('操作成功!')
              this.$Spin.hide()
              this.$emit('success')
              this.closeModal()
            })
            .catch(err => {
              this.$Notice.error({
                title: '操作失败!',
                desc: err.message
              })
              this.$Spin.hide()
              return null
            })
          } else {
            Api.Guarantee.applyGuaranteeRenewalNoSign(certSigned)
            .then(() => {
              this.$Message.success('操作成功!')
              this.$Spin.hide()
              this.$emit('success')
              this.closeModal()
            })
            .catch(err => {
              this.$Notice.error({
                title: '操作失败!',
                desc: err.message
              })
              this.$Spin.hide()
              return null
            })
          }
        }
      })
    },
    async certSigned (certSigned, callback) {
      console.log(certSigned)
      if (callback) {
        callback(certSigned)
      }
    },
    closeModal () {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.contract {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.contract-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
    cursor: pointer;
  }
  .contract-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .contract-thumb-cover{
    opacity: 1;
  }
  .contract-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>